(() => {
	const root = document.querySelector('[data-yp-unified="true"]');
	if (!root || root.dataset.ypPurchaseTrackingReady === 'true') return;
	root.dataset.ypPurchaseTrackingReady = 'true';
	root.querySelectorAll('[data-yp-unified-buy-url]').forEach(button => {
		button.addEventListener('click', () => {
			if (button.disabled) return;
			const raw = button.dataset.ypUnifiedBuyUrl;
			const analytics = window.YPAnalytics;
			const sku = analytics?.checkoutSku(raw);
			const url = new URL(raw, window.location.origin);
			if (url.origin !== window.location.origin || !/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?cart\/\d+:1$/.test(url.pathname)) return;
			const method = url.searchParams.get('attributes[checkout_method]');
			if (sku) {
				(window.YPUnifiedTracking || analytics).trackButtonClick(`unified_buy_${sku.tier.toLowerCase()}_${sku.duration.toLowerCase()}_${method}`);
				analytics.trackCheckoutStart(sku);
			}
			window.location.assign(analytics?.decorateCheckoutURL(url.href) || url.href);
		});
	});
	root.querySelectorAll('.yp-unified-wallet').forEach(wallet => {
		// Shopify exposes composed click events on these wallet hosts. Observe
		// their insertion, without accessing closed shadow DOM or altering payment.
		const methods = {
			'shopify-apple-pay-button': 'apple_pay',
			'shopify-google-pay-button': 'google_pay',
			'shop-pay-wallet-button': 'shop_pay',
			'shopify-paypal-button': 'paypal',
			'shopify-amazon-pay-button': 'amazon_pay',
		};
		const tracked = new WeakSet();
		const bindWalletClicks = () => {
			if (!['home','test'].includes(root.dataset.ypPage)) return;
			wallet.querySelectorAll(Object.keys(methods).join(',')).forEach(button => {
				if (tracked.has(button)) return;
				tracked.add(button);
				button.addEventListener('click', event => {
					if (wallet.hidden || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
					// A nested wallet host must not also count its generic outer host.
					const origin = event.composedPath().find(node => Object.hasOwn(methods, node.localName));
					if (origin !== button) return;
					const id = wallet.querySelector('input[name="id"]')?.value;
					const analytics = window.YPAnalytics;
					const sku = analytics?.checkoutSku(`/cart/${id}:1`);
					if (!sku) return;
					(window.YPUnifiedTracking || analytics).trackButtonClick(`unified_buy_${sku.tier.toLowerCase()}_${sku.duration.toLowerCase()}_${methods[button.localName]}`);
					// A wallet sheet can be cancelled. Actual checkout/purchase events
					// remain with Shopify's checkout pixel, not this click handler.
				}, {capture: true});
			});
		};
		const syncFallback = () => {
			const unbranded = wallet.querySelector('shopify-buy-it-now-button[slot="button"] .shopify-payment-button__button--unbranded');
			wallet.hidden = Boolean(unbranded);
		};
		syncFallback();
		bindWalletClicks();
		new MutationObserver(() => { syncFallback(); bindWalletClicks(); }).observe(wallet, { childList: true, subtree: true });
	});
})();
